"use client"
import {
  theme_setter_default
} from "./chunk-ZWAYVYGR.js";

// src/client/scroll-observer.tsx
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useRef, useState } from "react";
import { jsx } from "react/jsx-runtime";
gsap.registerPlugin(ScrollTrigger, useGSAP);
function ScrollObserver({
  useSelf = false,
  theme = void 0
}) {
  const ref = useRef(null);
  const [variation, setVariation] = useState(void 0);
  useGSAP(() => {
    let baseTheme = theme;
    const parent = ref.current?.parentElement;
    if (!useSelf) {
      const sibling = parent?.querySelector(".module-wrapper");
      if (sibling) {
        baseTheme = sibling.classList.contains("theme-dark-transparent") ? "theme-dark-transparent" : sibling.classList.contains("theme-dark") ? "theme-dark" : "theme-light";
      } else {
        return;
      }
    }
    const mm = gsap.matchMedia();
    mm.add(
      {
        isDesktop: "(min-width: 1024px)",
        isMobile: "(max-width: 1023px)"
      },
      (context) => {
        const { isMobile } = context.conditions;
        const headerHeight = Number.parseFloat(
          getComputedStyle(document.body).getPropertyValue(
            isMobile ? "--header-height-mobile" : "--header-height"
          )
        );
        ScrollTrigger.create({
          trigger: parent,
          start: `top top+=${0.5 * headerHeight}`,
          end: `bottom top+=${0.5 * headerHeight}`,
          onEnter: () => {
            setVariation(baseTheme);
          },
          onEnterBack: () => {
            setVariation(baseTheme);
          },
          onLeave: () => {
            setVariation(void 0);
          },
          onLeaveBack: () => {
            setVariation(void 0);
          }
        });
      }
    );
  });
  return /* @__PURE__ */ jsx("span", { className: "scroll-observer", ref, children: /* @__PURE__ */ jsx(theme_setter_default, { variation }) });
}

export {
  ScrollObserver
};
